export default "__VITE_ASSET__QQUQLFSs__"